import type { StructureType } from "../../api/structures/structures.types";

export type StructureModalTabId =
  | "generalData"
  | "raisingHistory"
  | "geometryDam"
  | "geometry"
  | "hydrology"
  | "reservoirManagement"
  | "anmClassification"
  | "regionalClassification"
  | "riskMapping";

export type StructureModalTabConfig = {
  value: StructureModalTabId;
  labelKey: string;
  disabled?: boolean;
};

const DAM_TABS: StructureModalTabId[] = [
  "generalData",
  "raisingHistory",
  "geometryDam",
  "hydrology",
  "reservoirManagement",
  "anmClassification",
  "regionalClassification",
  "riskMapping",
];

const STOCKPILE_TABS: StructureModalTabId[] = [
  "generalData",
  "geometry",
  "hydrology",
];

const OPEN_PIT_TABS: StructureModalTabId[] = ["generalData", "geometry"];

const tabLabelKey = (tabId: StructureModalTabId): string =>
  `admin.structures.modal.tab.${tabId}`;

const tabIdsForType = (
  effectiveType: StructureType | null | undefined,
): StructureModalTabId[] => {
  if (effectiveType == null) {
    return ["generalData"];
  }
  if (effectiveType === "stockpile") {
    return STOCKPILE_TABS;
  }
  if (effectiveType === "openPit") {
    return OPEN_PIT_TABS;
  }
  return DAM_TABS;
};

/** Abas visíveis por tipo; antes do gate F15 só Dados gerais fica habilitada. */
export const buildStructureModalTabConfigs = (
  effectiveType: StructureType | null | undefined,
  typePersisted: boolean,
): StructureModalTabConfig[] => {
  const tabIds = tabIdsForType(effectiveType);

  return tabIds.map((value) => ({
    value,
    labelKey: tabLabelKey(value),
    disabled: !typePersisted && value !== "generalData",
  }));
};
